<template>
  <footer class="footer">
    <main class="footer__container l-page-content">
      <div class="footer__block">
        <a class="footer__phone" href="tel:+88002002518">8 800 200-25-18</a>
        <p>Бесплатно по России</p>
        <a class="footer__email" href="mailto:support@loy.ru">support@loy.club</a>
      </div>

      <div class="footer__nav-wrap">
        <ul class="footer__nav footer__block">
          <li>
            <a class="footer__nav-link" href="#">О системе лояльности</a>
          </li>
          <li>
            <a class="footer__nav-link" href="#">Партнерам</a>
          </li>
          <li>
            <a class="footer__nav-link" href="#">Поддержка</a>
          </li>
        </ul>

        <ul class="footer__subnav footer__block">
          <!--<li>-->
            <!--<a class="footer__subnav-link" href="#">Публичная оферта</a>-->
          <!--</li>-->
          <li>
            <a class="footer__subnav-link" href="/legal/privacy-policy.pdf" target="_blank">
              Политика конфиденциальности
            </a>
          </li>
        </ul>
      </div>

      <div class="footer__block">
        <Socials />
      </div>
    </main>

    <div class="footer__right l-page-content footer__block">
      &#169; 2022, ООО «Комтет», официальный сайт
    </div>
  </footer>
</template>

<script>
import Socials from './components/Socials.vue';

export default {
  components: { Socials },
};
</script>

<style lang="scss" scoped>
.footer {
  padding: 3rem 0;
  background-color: #1b2129;

  &__container {
    display: flex;

    @include device-until(tablet) {
      flex-direction: column;
      text-align: center;
    }
  }

  &__block {
    text-align: center;

    @include device-until(tablet) {
      padding: 1rem 0;
    }
  }

  &__nav-wrap {
    margin: 0 auto;
    font-weight: 600;

    li {
      display: inline-block;
      line-height: 2.2;

      &:not(:last-child) {
        margin-right: 1rem;
      }

      @media (max-width: 876px) {
        display: block;
        margin-right: 0;
      }
    }
  }

  &__nav {
    list-style: none;
    font-size: 1.125rem;
  }

  &__nav-link {
    color: #586bff;
    padding: 0;
  }

  &__subnav {
    list-style: none;
    font-weight: 600;
  }

  &__subnav-link {
    color: #848d92;
  }

  &__phone {
    font-size: 1.5rem;
    font-weight: 500;
    color: #fefefe;
  }

  &__email {
    color: #fefefe;
  }

  &__right {
    text-align: right;
  }
}
</style>
